import gsap from "gsap";

var tl_main = gsap.timeline({paused: true})
    .to('.p-char-L', 1.7, { autoAlpha: 1, x:0, y:0, ease: "Power1.easeOut", delay: .3})
    .to('.p-char-R', 1.7, { autoAlpha: 1, x:0, y:0, ease: "Power1.easeOut" },"-=1.7")
    .to('.p-main__tit', 1.37, { autoAlpha: 1, y:0, ease: "Power1.easeOut" },"-=1.7")
    .to('.p-footer', 0.6, { autoAlpha: 1, y:0, ease: "Power1.easeOut" },"-=1")
    .to('.p-timeline__item1', 0.7, { autoAlpha: 1, x:0, ease: "Power1.easeOut" },"-=0.74")
    .to('.p-timeline__item2', 0.7, { autoAlpha: 1, x:0, ease: "Power1.easeOut" },"-=0.6")
    .to('.p-timeline__item3', 0.7, { autoAlpha: 1, x:0, ease: "Power1.easeOut" },"-=0.6")
    .to('.p-timeline__item4', 0.7, { autoAlpha: 1, x:0, ease: "Power1.easeOut" },"-=0.6");

var tl_section1 = gsap.timeline({paused: true})
    .to('.p-sec1__tit', 1.1, { autoAlpha: 1, y:0, ease: "Power1.easeOut", delay: .2})
    .to('.p-sec1__cont ul + p', 0.6, { autoAlpha: 1, y:0, ease: "Power1.easeOut" },"-=.1")
    .to('.p-btn--coupon', 0.6, { autoAlpha: 1, y:0, ease: "Power1.easeOut" },"-=.6")
    .to('.p-sec1__cont ul li:nth-child(1)', 0.7, { autoAlpha: 1, x:0, ease: "Power1.easeOut" },"-=0.8")
    .to('.p-sec1__cont ul li:nth-child(2)', 0.7, { autoAlpha: 1, x:0, ease: "Power1.easeOut" },"-=0.6")
    .to('.p-sec1__cont ul li:nth-child(3)', 0.7, { autoAlpha: 1, x:0, ease: "Power1.easeOut" },"-=0.6")

var tl_section2 = gsap.timeline({paused: true})
    .to('.p-sec2__tit', 1.3, { autoAlpha: 1, y:0, ease: "Power1.easeOut", delay: .2})
    .to('.p-sec2__cont', 0.6, { autoAlpha: 1, y:0, ease: "Power1.easeOut" },"-=.7")
    // .to('.p-btn--classReboot', 0.6, { autoAlpha: 1, y:0, ease: "Power1.easeOut" },"-=1")
/*
    .to('.p-btn--itemRebalancing', 0.6, { autoAlpha: 1, y:0, ease: "Power1.easeOut" },"-=1")
    .to('.p-sec2__cont ul li:nth-child(1)', 0.7, { autoAlpha: 1, x:0, ease: "Power1.easeOut" },"-=0.8")
    .to('.p-sec2__cont ul li:nth-child(2)', 0.7, { autoAlpha: 1, x:0, ease: "Power1.easeOut" },"-=0.6")
    .to('.p-sec2__cont ul li:nth-child(3)', 0.7, { autoAlpha: 1, x:0, ease: "Power1.easeOut" },"-=0.6")
    .to('.p-sec2__cont ul li:nth-child(4)', 0.7, { autoAlpha: 1, x:0, ease: "Power1.easeOut" },"-=0.6")
*/

promokit.preload({});

$('.p-timeline__item1').on('click', function () {
    promokit.store('page').to(1);
});
$('.p-timeline__item2').on('click', function () {
    promokit.store('page').to(2);
});

var _youtube = promokit.youtube({
    el: '#youtube-player',
    youtubeId: '--tpHxLMsfc',
    controls: true,
    mute: false
});
promokit.layer({
    el: '#layer-youtube',
    buttons: '.p-btn--classReboot',
    autoplayVideo: _youtube
});

var current_network;

let networkLink = {
    "local":"https://op-wstatic.ncsoft.com/promo/lineage/history/2021/210428_convulsion/img/",
    "op":"https://op-wstatic.ncsoft.com/promo/lineage/history/2021/210428_convulsion/img/",
    "rc":"https://rc-wstatic.plaync.co.kr/promo/lineage/history/2021/210428_convulsion/img/",
    "live":"https://wstatic-cdn.plaync.com/promo/lineage/history/2021/210428_convulsion/img/",
};

$.each(networkLink, function(key, value){
    if(promokitStore.network==key){
        current_network = value;
    }
});

promokit.page({
    type: 'fullpage-vertical',

    parallax: true,

    components: [
        {
            id: '#section-header',
            name: 'section header',
            backgroundImage: current_network + 'PC/bg.jpg',
        },
        {
            id: '#section-1',
            name: 'section 1',
            backgroundImage: current_network + 'PC/bg2.jpg'
        },
        {
            id: '#section-2',
            name: 'section 2',
            backgroundImage: current_network + 'PC/bg3.jpg'
        }
    ],

    el: '#container',

    game: 'lineage',

    menu: false,

    cnb: true,

    footer: {
        fixed: true,
        theme: 'white'
    },

    headerButton: {
        cookie: {
            type: 'year',
            key: 'INDEX_WEB_VISIT_210428_convulsion',
            value: false
        },
        event: false,
        update: true,
        home: true,
        sns: true,
        theme: 'white'
    },
    changestart: function(params){
        switch (params.to) {
            case 0:
                tl_main.seek(0);
                break;
            case 1:
                tl_section1.seek(0);
                break;
            case 2:
                tl_section2.seek(0);
                break;
        }
    },
    changeend: function (params) {
        switch (params.to) {
            case 0:
                tl_main.play();
                break;
            case 1:
                tl_section1.play();
                break;
            case 2:
                tl_section2.play();
                break;
        }
    }
});


// WEBPACK FOOTER //
// ./src/js/index.js